/**
 * Module d'authentification frontend — Google Sign-In.
 */

const TOKEN_KEY = 'grocewise-auth-token';
const USER_KEY = 'grocewise-user';
const API_BASE = '/api';

export const GOOGLE_CLIENT_ID = '600077698279-1gg28uposqju0v18vvue3nj951e3p4ja.apps.googleusercontent.com';

// --- Token & user storage ---

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearUser() {
  localStorage.removeItem(USER_KEY);
}

export function isLoggedIn() {
  return !!getToken();
}

// --- Fetch avec auth ---

export async function authFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const resp = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (!resp.ok) {
    if (resp.status === 401) {
      clearToken();
      clearUser();
    }
    let message = `Erreur HTTP ${resp.status}`;
    try {
      const body = await resp.json();
      if (body.detail) {
        message = typeof body.detail === 'string' ? body.detail : JSON.stringify(body.detail);
      }
    } catch { /* ignore */ }
    throw new Error(message);
  }

  if (resp.status === 204) return null;
  return resp.json();
}

// --- Google Sign-In ---

export async function loginWithGoogle(credential) {
  const resp = await fetch(`${API_BASE}/auth/google`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ credential }),
  });

  if (!resp.ok) {
    const body = await resp.json().catch(() => ({}));
    throw new Error(body.detail || 'Erreur de connexion Google');
  }

  const data = await resp.json();
  setToken(data.access_token);
  setUser(data.user);
  return data.user;
}

export function logout() {
  clearToken();
  clearUser();
}

export async function fetchMe() {
  return authFetch('/auth/me');
}
